import { Typography } from '@mui/material';

export default function BlockNameHeading({ title }) {
  return (
    <Typography
      sx={{
        fontFamily: 'Lato',
        fontSize: '1.4rem',
        fontWeight: 900,
        lineHeight: '20px',
        textAlign: 'center',
        color: '#39585C',
      }}
    >
      {title}
    </Typography>
  );
}
